import Vue from 'vue'
import Vuex from 'vuex'
import newsa from '@/imgs/newsa.png'
import newsaa from '@/imgs/newsaa.png'
import newsb from '@/imgs/newsb.png'
import newsbb from '@/imgs/newsbb.png'
import newsc from '@/imgs/newsc.png'
import newscc from '@/imgs/newscc.png'
import newsd from '@/imgs/newsd.png'
import newsdd from '@/imgs/newsdd.png'
import newse from '@/imgs/newse.png'
import newsee from '@/imgs/newsee.png'
import newsf from '@/imgs/newsf.png'
import newsff from '@/imgs/newsff.png'
import newsg from '@/imgs/newsg.png'
import newsgg from '@/imgs/newsgg.png'
import newsh from '@/imgs/newsh.png'
import newshh from '@/imgs/newshh.png'
import newsi from '@/imgs/newsi.png'
import newsii from '@/imgs/newsii.png'
import newsj from '@/imgs/newsj.png'
import newsjj from '@/imgs/newsjj.png'
import newsk from '@/imgs/newsk.png'
import newskk from '@/imgs/newskk.png'
import newsl from '@/imgs/newsl.png'
import newsll from '@/imgs/newsll.png'
import newsmm from '@/imgs/newsmm.jpg'
import newsnn from '@/imgs/newsnn.jpg'
import newsoo from '@/imgs/newsoo.jpg'
Vue.use(Vuex)
export default new Vuex.Store({
  state:	{
    PopupShow: false,
    popupImg: true,
    newsimgs: [
      {imgUrl: newsa, activeImgUrl: newsaa},
      {imgUrl: newsb, activeImgUrl: newsbb},
      {imgUrl: newsc, activeImgUrl: newscc},
      {activeImgUrl: newsnn},
      {imgUrl: newse, activeImgUrl: newsee},
      {imgUrl: newsf, activeImgUrl: newsff},
      {imgUrl: newsg, activeImgUrl: newsgg},
      {imgUrl: newsh, activeImgUrl: newshh},
      {imgUrl: newsi, activeImgUrl: newsii},
      {imgUrl: newsj, activeImgUrl: newsjj},
      {imgUrl: newsk, activeImgUrl: newskk},
      {imgUrl: newsl, activeImgUrl: newsll},
      {activeImgUrl: newsmm},
      {imgUrl: newsd, activeImgUrl: newsdd},
      {activeImgUrl: newsoo}
    ],
    initInfo: {
      dutyone: '1、负责金融产品的信用评估模型建设，通过大数据分析，建立信贷业务信用评分模型，客户资信模型等数据模型，用于金融服务和信贷业务的发展；￡2、信贷风控模型设计与开发：负责信贷风控模型的设计、开发、测试和实施，包括但不局限于申请评分模型、行为评分模型、催收评分模型、反欺诈模型等的框架设计开发；￡3、信贷模型策略实施：将模型应用到金融业务的风险管理流程中，通过模型的判断和计算，对用户行为及表现做出准确的预判，并采取相应的措施进行控制；￡4、项目管理：负责与产品、运营、风控、系统开发部门对接，确保模型量化策略的准确实施，以及上线后的监控优化；￡5、授信决策模型：通过对基础数据的清洗和管理，建立模型框架，实施模型建设，并利用模型对用户的信用进行评分，并根据评分结果输出业务决策；￡6、其他应用类数据模型。',
      reqinfoone: '1、本科及以上学历，金融、经济、会计、数学、统计、计算机、工程等专业；￡2、3年以上数据分析、数据挖掘及模型开发经验（有IT大数据分析经验，咨询公司数据分析经验、互联网金融数据建模分析经验者优先）；￡3、熟练掌握和使用常用的风险模型如线性回归、逻辑回归、决策树、聚类分析的基本的统计学工具，熟练使用SAS/R，Python，SQL，VBA，Excel；￡4、文本数据的分析与挖掘（文本分类，关键词提取，聚类，主题分析，情感分析等）有一定知识者加分。',
      dutytwo: '1、分析转化率数据，及时发现业务问题，并推动RD、PM、QA解决；￡2、通过数据分析和大胆尝试，寻找提升转化率的方案，提升业务数据；￡3、关注竞品动态，了解市面上的数据提供公司，对业务的变化能及时做出调整方案。',
      reqinfotwo: '1、本科及以上学历，理工科专业（计算机专业、数学统计学专业优先）；￡2、有电商类、金融产品（用户型产品）类核心流程的产品者优先；￡3、熟练使用axure、Visio、mindmanager等工具；￡4、过硬的沟通能力，有很好的逻辑性及数据分析能力，熟练使用SQL进行数据查询和分析。',
      dutythree: '1、负责公司内部各系统的架构梳理，提出合理的架构规划与设计；￡2、预研新技术，做公司内部的技术培训和推广工作；￡3、主导公司各项目的架构评审；￡4、承担核心模块和公共模块的代码编写。',
      reqinfothree: '1、本科及以上学历，计算机类相关专业，5年及以上JAVA开发工作经验；￡2、有大型分布式、高并发、高负载、高可用系统架构、设计、开发和调优经验；￡3、熟悉移动App、前端技术，有金融系统或者电商交易系统设计经验优先；￡4、基础扎实，深入理解IO，多线程，集合等基础框架；￡5、熟悉Spring，MyBatis/Hibernate等开源框架，熟悉Linux，MySQL以及其他大型数据库；￡6、精通面向对象设计原则，熟悉领域模型设计；￡7、有良好的沟通、学习和逻辑思维能力，有主动性和责任心。',
      dutyfour: '1、根据需求，参与系统设计，完成代码编写；￡2、进行各系统维护与后续迭代。',
      reqinfofour: '1、本科及以上学历，计算机相关专业，3年及以上JAVA开发工作经验；￡2、良好代码编写习惯；￡3、参与过高并发、大用户量移动互联网产品优先；￡4、熟悉Linux常用命令，了解Nginx，熟悉自动化部署；￡5、对各种框架Spring，hibernate或mybatis有深入了解；￡6、熟练分布式服务，Dubbo，Spring Cloud工具集优先考虑；￡7、工作习惯良好：自驱动，擅于合作，代码清晰整洁。',
      dutyfive: '1、与各个业务部门协调对接，梳理业务流程，完成前端产品与业务流程设计；￡2、对转化率、用户体验负责，监控产品数据，达成相关目标；￡3、通过用户数据分析、用户调研，梳理业务流程及发现业务问题，持续对产品进行优化与迭代；￡4、协调设计、研发、测试、运维等相关团队，完成项目落地。',
      reqinfofive: '1、本科及以上学历，金融、经济、信通、计算机、统计学专业优先；￡2、综合的产品经理基础素质，包括沟通能力、文档撰写、工具使用；￡3、2年以上的用户端产品工作经验，能够协调资源完成版本迭代；￡4、做过互金贷款产品经理，有独立负责业务经验的人优先；￡5、具有数据分析能力，严谨的逻辑性、用户体验能力自驱力、责任心者优先；￡6、具备英语工作能力。',
      dutysix: '1、建立互联网信贷业务反欺诈体系，设计贷款反欺诈流程、优化规则策略；￡2、制订和修订交易欺诈风险管控规则，并对规则效果进行跟踪和评估，对出现的风险案件进行深度挖掘，完善反欺诈体系；￡3、制定针对欺诈团伙、中介的欺诈行为的监控、反制、预防策略；￡4、借助内外部数据、工具等其他信息来源，进行反欺诈流程设计和优化；￡5、通过数据分析，建立交易欺诈行为早期预警，为提前管控提供政策依据。',
      reqinfosix: '1、统招本科及以上学历；￡2、三年及以上信用卡、互联网金融等机构相关工作经验优先；￡3、具有敏锐的风险意识，熟悉欺诈案件调查方法和管理，能及时运用调查结果对反欺诈策略体系进行升级优化。'
    },
    jobList: [
      {
        id: 0,
        text: '风控策略模型',
        jobInfo: [
          {
            id: 0,
            jobName: '模型算法工程师',
            duty: '1、负责金融产品的信用评估模型建设，通过大数据分析，建立信贷业务信用评分模型，客户资信模型等数据模型，用于金融服务和信贷业务的发展；￡2、信贷风控模型设计与开发：负责信贷风控模型的设计、开发、测试和实施，包括但不局限于申请评分模型、行为评分模型、催收评分模型、反欺诈模型等的框架设计开发；￡3、信贷模型策略实施：将模型应用到金融业务的风险管理流程中，通过模型的判断和计算，对用户行为及表现做出准确的预判，并采取相应的措施进行控制；￡4、项目管理：负责与产品、运营、风控、系统开发部门对接，确保模型量化策略的准确实施，以及上线后的监控优化；￡5、授信决策模型：通过对基础数据的清洗和管理，建立模型框架，实施模型建设，并利用模型对用户的信用进行评分，并根据评分结果输出业务决策；￡6、其他应用类数据模型。',
            reqinfo: '1、本科及以上学历，金融、经济、会计、数学、统计、计算机、工程等专业；￡2、3年以上数据分析、数据挖掘及模型开发经验（有IT大数据分析经验，咨询公司数据分析经验、互联网金融数据建模分析经验者优先）；￡3、熟练掌握和使用常用的风险模型如线性回归、逻辑回归、决策树、聚类分析的基本的统计学工具，熟练使用SAS￡R，Python，SQL，VBA，Excel；￡4、文本数据的分析与挖掘（文本分类，关键词提取，聚类，主题分析，情感分析等）有一定知识者加分。'
          }
        ]
      },
      {
        id: 1,
        text: '产品部',
        jobInfo: [
          {
            id: 0,
            jobName: '高级产品经理',
            duty: '1、分析转化率数据，及时发现业务问题，并推动RD、PM、QA解决；￡2、通过数据分析和大胆尝试，寻找提升转化率的方案，提升业务数据；￡3、关注竞品动态，了解市面上的数据提供公司，对业务的变化能及时做出调整方案。',
            reqinfo: '1、本科及以上学历，理工科专业（计算机专业、数学统计学专业优先）；￡2、有电商类、金融产品（用户型产品）类核心流程的产品者优先；￡3、熟练使用axure、Visio、mindmanager等工具；￡4、过硬的沟通能力，有很好的逻辑性及数据分析能力，熟练使用SQL进行数据查询和分析。'
          },
          {
            id: 1,
            jobName: '高级视觉设计师',
            duty: '1、负责公司整体活动设计，配合新媒体完成高质量创意作品；￡2、负责产品相关的宣传、推广物料创意设计；￡3、能推进定义优秀设计实践，提升设计价值和团队设计标准；￡4、参与设计体验、优化设计流程，以结果和高效为导向，不断在大众化与产品个性差异化之间找到平衡点。',
            reqinfo: '1、3年以上的互联网或移动互联网产品设计经验；￡2、热爱视觉设计，时刻关注与把握设计趋势，了解交互设计；￡3、有海外设计项目经验，有手绘能力，广告公司经验，优先考虑。'
          }
        ]
      },
      {
        id: 2,
        text: '研发',
        jobInfo: [
          {
            id: 0,
            jobName: '架构师',
            duty: '1、负责公司内部各系统的架构梳理，提出合理的架构规划与设计；￡2、预研新技术，做公司内部的技术培训和推广工作；￡3、主导公司各项目的架构评审；￡4、承担核心模块和公共模块的代码编写。',
            reqinfo: '1、本科及以上学历，计算机类相关专业，5年及以上JAVA开发工作经验；￡2、有大型分布式、高并发、高负载、高可用系统架构、设计、开发和调优经验；￡3、熟悉移动App、前端技术，有金融系统或者电商交易系统设计经验优先；￡4、基础扎实，深入理解IO，多线程，集合等基础框架；￡5、熟悉Spring，MyBatis/Hibernate等开源框架，熟悉Linux，MySQL以及其他大型数据库；￡6、精通面向对象设计原则，熟悉领域模型设计；￡7、有良好的沟通、学习和逻辑思维能力，有主动性和责任心。'
          },
          {
            id: 1,
            jobName: '高级iOS工程师',
            duty: '1、主要负责iOS的应用程序设计、开发；￡2、负责iOS移动设备上产品开发，配合市场与产品设计团队快速开发iOS应用程序；￡3、能够独立完成iOS软件开发，验证和修正测试中发现的问题； ￡4、学习和研究新技术以满足产品的需求，根据开发过程中的体验对产品提出改进建议； ￡5、根据产品策划提出的需求独立完成iOS应用开发。',
            reqinfo: '1、本科以上学历，计算机、软件相关专业，3-5年iOS开发经验；￡2、熟练掌握内存及性能的优化；￡3、熟练掌握Objective-C 和 Swift语言；￡4、熟练掌握常用的第三方类库并了解其底层实现，能独立封装常用的类库、组件；￡5、熟练掌握MVC、MVVM等架构；￡6、灵活运用各种设计模式及编程思想；￡7、对数据结构、算法、内存管理有深入了解优先；￡8、良好的编程习惯，代码规范；￡9、要有技术分享的精神，具有良好的团队协作和沟通能力。'
          },
          {
            id: 2,
            jobName: '高级web工程师',
            duty: '1、负责公司BI平台的HTML5相关内容的页面开发；￡2、根据需求，从技术的角度进行评估，并给出建议，推动用户体验的优化。',
            reqinfo: '1、本科以上学历，计算机软件相关专业，2年及以上的HTML开发经验，有完整项目开发经验者优先；￡2、熟悉Web前端开发技术，包括JavaScript、Ajax、CSS等web开发领域相关技术；￡3、熟悉html5在Android和iOS应用程序开发，移动客户端开发；￡4、熟悉JavaScript/JSON等Web前端技术。'
          },
          {
            id: 3,
            jobName: '高级Android工程师',
            duty: '1、负责移动端产品的功能研发和性能优化，完成高质量编码工作； ￡2、和产品经理配合，设计良好的代码结构，不断迭代重构；￡3、良好的沟通以及团队协作能力。',
            reqinfo: '1、本科以上学历，至少3年以上Android应用开发经验；￡2、熟悉java语言，在数据结构、算法、设计模式和架构上有扎实的技术功底熟悉主流的android应用设计思路、开发框架；￡3、具备有效的沟通能力、团队协作意识和工作责任心；￡4、有导师经验，具备带人能力，做事认真仔细。'
          }
        ]
      },
      {
        id: 3,
        text: '研究院',
        jobInfo: [
          {
            id: 0,
            jobName: '高级Java工程师',
            duty: '1、根据需求，参与系统设计，完成代码编写；￡2、进行各系统维护与后续迭代。',
            reqinfo: '1、本科及以上学历，计算机相关专业，3年及以上JAVA开发工作经验；￡2、良好代码编写习惯；￡3、参与过高并发、大用户量移动互联网产品优先；￡4、熟悉Linux常用命令，了解Nginx，熟悉自动化部署；￡5、对各种框架Spring，hibernate或mybatis有深入了解；￡6、熟练分布式服务，Dubbo，Spring Cloud工具集优先考虑；￡7、工作习惯良好：自驱动，擅于合作，代码清晰整洁。'
          },
          {
            id: 1,
            jobName: '高级大数据工程师（spark）',
            duty: '1、负责基于公司大数据平台的各类数据产品的研发工作；￡2、分析和解决具体的在使用平台的过程中出现的疑难问题；￡3、根据生产场景，对开源软件进行扩展开发，以满足特殊需求；￡4、调研，分析新技术，促进平台进化任职资格。',
            reqinfo: '1、熟悉Java、Scala等JVM语言，熟悉JVM原理和调优，最好熟悉JNI；￡2、熟悉一个脚本语言，比如PHP、Python等；￡3、熟悉Linux操作系统，熟悉Shell脚本；￡4、掌握基础的通用的数据平台相关的开源软件，熟悉它们的原理、实现、安装、部署、调优，具备精准选型和扩展开发的能力；￡5、熟悉相关开源软件，比如：Hadoop（HDFS、YARN）、HBase、Spark、Storm、Zookeeper、Kafka、HAWQ、Presto、Tachyon等；￡6、对大数据平台生态的发展，有敏感性和前瞻性，对新技术和新系统有基本的快速学习能力。'
          }
        ]
      },
      {
        id: 4,
        text: '新业务',
        jobInfo: [
          {
            id: 0,
            jobName: '产品运营经理（印尼）',
            duty: '1、与各个业务部门协调对接，梳理业务流程，完成前端产品与业务流程设计；￡2、对转化率、用户体验负责，监控产品数据，达成相关目标；￡3、通过用户数据分析、用户调研，梳理业务流程及发现业务问题，持续对产品进行优化与迭代；￡4、协调设计、研发、测试、运维等相关团队，完成项目落地。',
            reqinfo: '1、本科及以上学历，金融、经济、信通、计算机、统计学专业优先；￡2、综合的产品经理基础素质，包括沟通能力、文档撰写、工具使用；￡3、2年以上的用户端产品工作经验，能够协调资源完成版本迭代；￡4、做过互金贷款产品经理，有独立负责业务经验的人优先；￡5、具有数据分析能力，严谨的逻辑性、用户体验能力自驱力、责任心者优先；￡6、具备英语工作能力。'
          }
        ]
      },
      {
        id: 5,
        text: '风险运营',
        jobInfo: [
          {
            id: 0,
            jobName: '反欺诈经理',
            duty: '1、建立互联网信贷业务反欺诈体系，设计贷款反欺诈流程、优化规则策略；￡2、制订和修订交易欺诈风险管控规则，并对规则效果进行跟踪和评估，对出现的风险案件进行深度挖掘，完善反欺诈体系；￡3、制定针对欺诈团伙、中介的欺诈行为的监控、反制、预防策略；￡4、借助内外部数据、工具等其他信息来源，进行反欺诈流程设计和优化；￡5、通过数据分析，建立交易欺诈行为早期预警，为提前管控提供政策依据。',
            reqinfo: '1、统招本科及以上学历；￡2、三年及以上信用卡、互联网金融等机构相关工作经验优先；￡3、具有敏锐的风险意识，熟悉欺诈案件调查方法和管理，能及时运用调查结果对反欺诈策略体系进行升级优化。'
          }
        ]
      }

    ]

  },
  mutations: {
    change (state) {
	  state.PopupShow = !state.PopupShow
    },
    changeimg (state, params) {
      if (params.language == 'en') {
        state.popupImg = false
      } else {
        state.popupImg = true
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js